<template>
  <div
    class="mention-hover-card d-flex align-center pa-4"
    data-locator="mention-hover-card"
  >
    <app-avatar
      class="mr-3"
      :initials="initials"
      :color="avatarColor"
      :border-color="avatarBorderColor"
      :background-color="avatarBackgroundColor"
      size="m"
    />

    <div class="mention-hover-card__content">
      <div
        class="mention-hover-card__name mb-1"
        data-locator="mention-hover-card-name"
      >
        {{ displayName }}
      </div>

      <div
        v-if="subtitle"
        class="mention-hover-card__info mb-1"
        data-locator="mention-hover-card-subtitle"
      >
        {{ subtitle }}
      </div>

      <div
        v-if="mentionable?.email"
        class="mention-hover-card__info"
        data-locator="mention-hover-card-email"
      >
        {{ mentionable.email }}
      </div>
    </div>
  </div>
</template>

<script>
import AppAvatar from '@/design-system/AppAvatar.vue'

export default {
  name: 'MentionHoverCard',
  components: {
    AppAvatar,
  },
  props: {
    mentionable: {
      type: Object,
      required: true,
    },
    avatarColor: {
      type: String,
      default: '#FF5D35',
    },
    avatarBackgroundColor: {
      type: String,
      default: '#FFEFEB',
    },
    avatarBorderColor: {
      type: String,
      default: '#FFDFD7',
    },
  },
  computed: {
    displayName () {
      return this.mentionable?.fullName || this.mentionable?.name || ''
    },
    initials () {
      return this.mentionable?.initials || ''
    },
    subtitle () {
      const parts = [
        this.mentionable?.userGroupName,
        this.mentionable?.company,
      ].filter(Boolean)

      return parts.length ? parts.join(', ') : null
    },
  },
}
</script>

<style scoped lang="scss">
.mention-hover-card {
  width: auto;
  background: rgb(var(--v-theme-white));
  border: 1px solid rgb(var(--v-theme-grey-200));
  border-radius: 8px;
  box-shadow: 0px 0px 12px 0px rgba(68, 74, 80, 0.08);

  &__content {
    min-width: 0;
    flex: 1;
  }

  &__name {
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    color: rgb(var(--v-theme-grey-800));
    word-break: break-word;
  }

  &__info {
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    color: rgb(var(--v-theme-grey-700));
    word-break: break-word;
  }
}
</style>
